import axios from 'axios';
import _authService from './AuthService';
import _notification from 'modules/notification';

import { SESSION_TOKEN, API_ROOT, GENERAL_ERROR_MESSAGE, LOGIN_TIME, VALIDATE_LICENCE_KEY } from 'constants/constants';
import moment from 'moment';


//export const instance = axios.create();
export const instance = axios.create({
	baseURL: API_ROOT,
	headers: {
		'Content-Type': 'application/json',
		'auth-token': localStorage[SESSION_TOKEN],
		//'Pragma': 'no-cache'
	}
});

export const instanceForFile = axios.create({
	baseURL: API_ROOT,
	responseType: 'arraybuffer',
	headers: {
		'auth-token': localStorage[SESSION_TOKEN],
	}
});

export const instanceForZip = axios.create({
	baseURL: API_ROOT,
	responseType: 'arraybuffer',
	headers: {
		'Content-Type': 'application/zip',
		'Accept': 'application/zip',
		'auth-token': localStorage[SESSION_TOKEN],
	}
});


// Add a response interceptor
instance.interceptors.response.use(function (response) {

	if (!window.__IsLiValid && !response.config.url.includes('ValidateLicenceKey') && response.config.url.includes('/Admin') ) {
		axios.get(API_ROOT + VALIDATE_LICENCE_KEY)
			.then((response) => {
				if (response.status == 200) {
					if (!response.data.IsSuccess) {
						_notification.showMessage('error', response.data.Message);
						window.location.href = "/InvalidLicence"
					}
					else {
						window.__IsLiValid = true;
					}
				}
			});
	}
	return response;
}, function (error) {
	if (error.response === undefined) {		
		_notification.showMessage('error', "Server Error, Please contact admin.");
		return Promise.reject(error);
	}

	if (error.response) {
		// Request made and server responded		
		var statusCode = error.response.status;
		if (statusCode == 401) {
			//_notification.showMessage('error', error.response.data.Message);
			//window.location.href = "/";

			if (moment(localStorage[LOGIN_TIME]).isValid() ? moment().diff(moment(localStorage[LOGIN_TIME]), 'minutes') : moment(moment(), 'minutes').diff() > 1) {
				if (window.location.href.includes("/admin/")) {
					_notification.showMessage('error', "Your session has expired. Please login again.");
					_authService.logout();

					window.setTimeout(() => {
						window.location.href = "/admin/login";
					}, 2000);
				}
			}

			if (moment(localStorage[LOGIN_TIME]).isValid() ? 
					moment().diff(moment(localStorage[LOGIN_TIME]), 'minutes') : 
					moment(moment(), 'minutes').diff() > 1) {
				if (!window.location.href.includes("/admin/")) {
					_notification.showMessage('error', "Your session has expired. Please login again.");
					_authService.logout();

					window.setTimeout(() => {
						window.location.href = "/";
					}, 2000);
				}
			}

			console.log("Login Time: ", window.location.href);
		} else {
			_notification.showMessage('error', GENERAL_ERROR_MESSAGE);
		}
		return Promise.reject(error.response.status);
	}
	return Promise.reject(error);
});

// // Add a response interceptor
// instance.interceptors.response.use(function (response) {
// 	return response;
// }, function (error) {
// 	if (error.response) {
// 		// Request made and server responded
// 		var statusCode = error.response.status;
// 		if (statusCode == 401) {
// 			//_validator.showToast('Unautorized User', 'error');
// 			console.log("Logout session MR");
// 			_authService.logout();
// 		} else if (statusCode == 409) {
// 			_notification.showMessage('error', 'Analysis is running, please try after some time.');
// 		} else {
// 			_notification.showMessage('error', GENERAL_ERROR_MESSAGE);
// 		}
// 		return Promise.reject(error.response.status);
// 	}
// 	return Promise.reject(error);
// });